import React from 'react';
import { withHydrate } from '@ecommerce/nest-ssr/common';

import StaticLayoutDesktop from 'layouts/static/static.desktop';
import { NewsItemInterface } from 'interfaces/news-item.interface';
import NewsArticle from 'components/news/article/news-article';

const NewsItemDesktop: React.FC<{ title: string; newsItem: NewsItemInterface; }> = ({ title, newsItem }) => (
    <StaticLayoutDesktop title={title}>
        <NewsArticle newsItem={newsItem}/>
    </StaticLayoutDesktop>
);

export default withHydrate(NewsItemDesktop, { root: '#root' }, 'views/pages/news/item/news-item.desktop');
